export const UNCATEGORIZED_TOPIC_KEY = "uncategorized";

export interface TopicTaggedVideo {
  topic_id?: string | null;
  topic_label?: string | null;
  topic_order?: number | null;
}

export interface VideoTopicGroup<T> {
  key: string;
  label: string;
  videos: T[];
}

/**
 * Buckets videos by topic, keeping each bucket's videos in their incoming
 * order. Buckets follow topic_order; uncategorized videos come last.
 */
export const groupVideosByTopic = <T extends TopicTaggedVideo>(
  videos: T[],
  uncategorizedLabel: string
): VideoTopicGroup<T>[] => {
  const groups = new Map<string, VideoTopicGroup<T> & { order: number }>();

  videos.forEach(video => {
    const key = video.topic_id || UNCATEGORIZED_TOPIC_KEY;
    let group = groups.get(key);
    if (!group) {
      group = {
        key,
        label: video.topic_id
          ? video.topic_label || "Untitled topic"
          : uncategorizedLabel,
        order: video.topic_id
          ? (video.topic_order ?? 0)
          : Number.MAX_SAFE_INTEGER,
        videos: [],
      };
      groups.set(key, group);
    }
    group.videos.push(video);
  });

  return Array.from(groups.values())
    .sort((a, b) => a.order - b.order)
    .map(({ key, label, videos: groupVideos }) => ({
      key,
      label,
      videos: groupVideos,
    }));
};
